import React, { useState } from "react";
import { connect } from "react-redux";
import LeadGen from "../../../Common/Popups/LeadGen";
import { increaseViewCount, getCookie } from "../../../Common/CommonMethods";
import ImageLoader from "../../../Common/ImageLoader";
import { openAPI } from "../../../../config";

const VendorCaseStudyLocked = (props) => {
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [isEntered, setIsEntered] = useState(false);
  const [vendorCaseStudy, setVendorCaseStudy] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props,
  });

  const handleExitUrl = (exit_url) => {
    openAPI
      .put(
        `${process.env.REACT_APP_API_URL}${exit_url.replace("/api/v1", "")}`,
        {},
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": `${getCookie("fc_react_csrfmiddlewaretoken")}`,
          },
        }
      )
      .then((response) => {
        if (!!response.data.exit_url) {
          openInNewTab(response.data.exit_url);
        }
      })
      .catch((error) => {});
  };

  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorCaseStudy,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorCaseStudy(tempObj);
    setIsEntered(false);
  };

  const openInNewTab = (href) => {
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href,
    }).click();
  };

  const postLeadRegPopUp = (isEnterpriseLoginStatus) => {
    setVendorCaseStudy({
      ...vendorCaseStudy,
      activeVideoPopUp: {
        isPopUpActive: true,
      },
      toLocation: props.pathname,
    });
    handleExitUrl(vendorCaseStudy.exit_url);
  };

  const showLeadGenPopUp = (leadGenFlag) => {
    const isVisitor = !!props.vendorProfile.visitor;
    if (!isVisitor && leadGenFlag === false) {
      return false;
    }
    if (!isVisitor && leadGenFlag === true) {
      return true;
    }
    if (isVisitor) {
      return false;
    }
  };

  const showUpgradePopUp = (leadGenFlag) => {
    const isVisitor = !!props.vendorProfile.visitor;
    if (!isVisitor && leadGenFlag === false) {
      return true;
    }
    if (!isVisitor && leadGenFlag === true) {
      return false;
    }
    if (isVisitor) {
      return false;
    }
  };

  return (
    <>
      <li>
        <img src="/images/blur_img02.png" alt="" />
        <div
          class="cls_content_locked"
          onClick={(e) => {
            e.preventDefault();
            if (showLeadGenPopUp(props.isLeadGenPopUp)) {
              setLeadGenPopUp(true);
            }
            if (showUpgradePopUp(props.isLeadGenPopUp)) {
              props.setUpgrade(true);
            }
          }}
        >
          <span class="locked">currently locked</span>
        </div>
        {isLeadGenPopUp ? (
          <LeadGen
            {...props}
            setLeadGenPopUp={setLeadGenPopUp}
            postLeadRegPopUp={postLeadRegPopUp(props.isEnterpriseLogin)}
            pathname={props.pathname.replace("/case-studies", "")}
            linkedInUrl={props.linkedInUrl}
            isLocked
          />
        ) : null}
      </li>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isEnterpriseLogin: state.homePage.isEnterpriseLogin,
  };
};
export default connect(mapStateToProps)(VendorCaseStudyLocked);
